import { jsx as _jsx } from "react/jsx-runtime";
import NativeSwiftHost from "../specs/OneSwiftHostNativeComponent";
import { decodeNativeSourceCallback, encodeNativeSourceProps } from "../native-source/wire.native";
function SwiftPackageView(param) {
  var { packageName, view, contractHash, props, fill, wires } = param;
  var encoded = wires ? encodeNativeSourceProps(props, wires.props, wires.structs) : props;
  return /* @__PURE__ */ _jsx(NativeSwiftHost, {
    packageName,
    view,
    contractHash,
    // a typed view's host learns which callbacks the element passed
    props: JSON.stringify(encoded, function(_key, value) {
      return typeof value === "function" ? true : value;
    }),
    fill,
    onHostEvent: function onHostEvent(event) {
      var callback = props[event.nativeEvent.name];
      if (typeof callback === "function") {
        var _ref;
        var args = JSON.parse(event.nativeEvent.args);
        var argWires = wires === null || wires === void 0 ? void 0 : wires.callbacks[event.nativeEvent.name];
        callback(...argWires ? decodeNativeSourceCallback(args, argWires, (_ref = wires === null || wires === void 0 ? void 0 : wires.structs) !== null && _ref !== void 0 ? _ref : {}, event.nativeEvent.name) : args);
      }
    },
    style: fill ? {
      flex: 1
    } : void 0
  });
}
export {
  SwiftPackageView
};
//# sourceMappingURL=index.native.js.map
